var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table table-striped table-bordered table-hover dataTable no-footer table-responsive",staticStyle:{"width":"100%"},attrs:{"id":"dt_basic","width":"100%","role":"grid","aria-describedby":"dt_basic_info"}},[_vm._t("header"),_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }